import { createSlice } from "@reduxjs/toolkit";

export const integrationGoalsSlice = createSlice({
    name: "integrationGoals",
    initialState: {
        goals: [],
        selectedGoals: []
    },
    reducers: {
        addGoals: (state, {payload}) => {
            let ar = [];
            let newPayload = payload ?? []
            newPayload.forEach(i => {
                if (ar[i.priorityOrder] === undefined) {
                    ar[i.priorityOrder] = i;
                }
            });
            state.goals = ar;
        },
        resetGoals: (state) => {
            state.goals = [];
            state.selectedGoals = [];
        },
        selectGoal: (state, {payload}) => {
            state.selectedGoals = [...state.selectedGoals, payload];
        },
        removeSelectedGoal: (state, {payload}) => {
            state.selectedGoals = state.selectedGoals.filter(i => i !== payload);
        },
        setGoals: (state, {payload}) => {
            const currentGoalsIds = state.goals.map(({goalId}) => goalId);
            const newAddedGoals = payload.filter(({goalId}) => !currentGoalsIds.includes(goalId));

            newAddedGoals.forEach(newAddedGoalId => distil.trackEvent('goal_shown', ' ', {goal_id: newAddedGoalId}));
            
            if(state.selectedGoals.length === 0) {
                state.selectedGoals = payload.map(g => g.goalId);
            }
            state.goals = payload;
        }
    }
})

export const { addGoals, resetGoals, selectGoal, removeSelectedGoal, setGoals } = integrationGoalsSlice.actions;

export default integrationGoalsSlice.reducer;
